export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
}
